<template>
  <div v-if="value && value.template_context" class="alert-content">
    <el-popover
      placement="bottom-start"
      trigger="hover"
      width="300"
      :content="
        $t('CampaignForm_ApplyTemplate_TemplateSelected_User', {
          who: value.template_context.who_applied,
          date: getTemplateAppliedDate()
        })
      "
    >
      <span
        slot="reference"
        class="template-text"
        v-if="value.template_context.id && value.template_context.is_deleted"
      >
        {{ $t('CampaignForm_ApplyTemplate_TemplateSelected_Deleted') }}
      </span>
      <span class="template-text" slot="reference" v-else>
        {{
          $t('CampaignForm_ApplyTemplate_TemplateSelected', {
            template: value.template_context.title
          })
        }}
      </span>
    </el-popover>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SelectedTemplateAlert',
  props: {
    value: {
      required: true
    }
  },
  methods: {
    getTemplateAppliedDate() {
      return moment(this.value.template_context.last_applied).format(
        'DD/MMM/YYYY HH:mm'
      )
    }
  }
}
</script>
<style scoped>
.alert-content {
  padding-top: 15px;
}
.template-text {
  float: right;
  color: #5c6374;
}
.el-popover {
  word-break: normal;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/SelectedTemplateAlert.vue